import { useContext } from "react";
import { getAppContext } from 'config/AppContext';
import Button from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { copyToClipboard } from "utilities/app-utilities";

type CopyButtonPropsType = {
    text: string;
    showAlways?: boolean
}

const CopyButton = (props: CopyButtonPropsType) => {
    if(!props.text && !props.showAlways) {
        return <></>;
    }

    const context = getAppContext(useContext);

    const copy = async () => {
        const copyResponse = await copyToClipboard(props.text);
        if(copyResponse.success) {
            context.notify('success', 'common.copied');
        } else {
            context.notify('error', `error.${copyResponse.error}`);
        }
    }

    return (
        <Button theme="link" title="common.copy" onClick={() => copy()}>
            <FontAwesomeIcon icon={faCopy} />
        </Button>
    );
}

export default CopyButton;
